module.exports = __webpack_public_path__ + "img/banner.df30c262.jpg";